<template>
	<v-dialog v-model="child_dialog" max-width="80%">
		<app-card>
			<v-card-title>
				<h3>Nhập thông tin {{ type ? type.toUpperCase() : "" }}</h3>
			</v-card-title>
			<v-form ref="form">
				<v-container fluid>
					<v-layout row wrap justify-center>
						<v-flex xs12 md3>
							<v-text-field
								label="username"
								prepend-icon="person"
								v-model="form.username"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="password"
								prepend-icon="vpn_key"
                                type="password"
								v-model="form.password"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3>
							<v-select
								label="db_name"
								v-model="form.db_name"
								:items="list_db"
								prepend-icon="all_inbox"
							></v-select>
						</v-flex>
						<v-flex xs12 md3>
							<v-select
								label="restore_from_db"
								v-model="form.restore_from_db"
								:items="list_db"
								prepend-icon="dns"
                                :disabled="disabled_restore_from_db"
							></v-select>
						</v-flex>
						<v-flex xs12 md6>
							<v-text-field
								label="folder_name"
								prepend-icon="description"
								v-model="form.folder_name"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="auth_db"
								prepend-icon="dns"
								v-model="form.auth_db"
								disabled
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="Type"
								prepend-icon="dns"
								v-model="type"
								disabled
							></v-text-field>
						</v-flex>
						<v-flex xs12>
							<v-btn
								@click="submit"
								:loading="loader"
								color="primary"
								:disabled="result_data != ''"
							>
								Submit
							</v-btn>
							<v-textarea
                                v-if="result_data"
                                outline
                                rows="10"
								label="Result Data"
								:value="result_data"
							></v-textarea>
						</v-flex>
					</v-layout>
				</v-container>
			</v-form>
		</app-card>
	</v-dialog>
</template>

<script>
import axios from "axios";
import appConfig from "Constants/AppConfig";

export default {
	name: "dialog-create-and-backup-db",
	props: {
		dialog: Boolean,
		folder_name: String,
		type: String
	},
	data() {
		return {
			child_dialog: false,
			form: {
				username: "admin",
				password: "dbadminpasswordahihi",
				auth_db: "am-db",
				db_name: "am-test",
				restore_from_db: "am-db",
				folder_name: ""
			},
			list_db: [
				{ text: "am-db", value: "am-db" },
				{ text: "am-test", value: "am-test" },
				{ text: "Trống", value: "" }
			],
            loader: false,
            result_data: "",
            disabled_restore_from_db: false,
		};
	},
	watch: {
		dialog(nv) {
			this.child_dialog = this.dialog;
			this.result_data = ""
		},
		child_dialog(nv) {
			this.$emit("changeDialogState", nv);
		},
		folder_name(nv) {
			this.form.folder_name = nv;
        },
        type(nv){
            if (nv == 'backup'){
                this.form.restore_from_db = ''
                this.form.db_name = 'am-db'
                this.disabled_restore_from_db = true
            } else {
                this.form.db_name = 'am-test'
                this.form.restore_from_db = 'am-db'
                this.disabled_restore_from_db = false
            }
        }
	},
	methods: {
		async submit() {
            this.result_data = ''
            this.loader = true;
            const postData = {
                ...this.form,
                type: this.type
            }
			const data = await axios({
				url:
					appConfig.production_host +
					"/api/admin/backup-restore-database",
                method: "post",
                data: postData,
				headers: {
					Authorization: "Bearer " + this.$store.state.auth.token
				}
			})
			.then(data => data)
			.catch(err => {
				console.log(err);
				console.log(err.response);
				swal.fire("Lỗi", err.response.data.message, 'error')
			});
			this.loader = false;
			this.result_data = data.data.data.data
			this.$emit("getBackupFolder")
		}
	}
};
</script>

<style>
</style>